// Ally CAG bundle + UI strings.
// Long-form prose context lives in markdown (./data/ally-context.md) so non-developers
// can edit the voice. Short UI strings + suggestions live in ./data/ally.json.

// Vite's `?raw` query imports the file as a string at build time.
import context from './data/ally-context.md?raw';
import ui from './data/ally.json';

export const allyContext: string = context;

export const allyGreeting: string = ui.greeting;
export const allyInputPlaceholder: string = ui.inputPlaceholder;
export const allyTriggerLabel: string = ui.triggerLabel;
export const allyPanelLabel: string = ui.panelLabel;
export const allyPanelSubtitle: string = ui.panelSubtitle;
export const allyCloseLabel: string = ui.closeLabel;
export const allySendLabel: string = ui.sendLabel;
export const allyMessageLabel: string = ui.messageLabel;
export const allySuggestions: ReadonlyArray<string> = ui.suggestions;
